/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidImportAuctionStatisticsResponseDto } from '../../models/prebid-import-auction-statistics-response-dto';

export interface GetPrebidImportAuctionStatistics$Params {
  source: string;
  'X-API-Version'?: string;
}

export function getPrebidImportAuctionStatistics(http: HttpClient, rootUrl: string, params: GetPrebidImportAuctionStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportAuctionStatisticsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getPrebidImportAuctionStatistics.PATH, 'get');
  if (params) {
    rb.query('source', params.source, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidImportAuctionStatisticsResponseDto>;
    })
  );
}

getPrebidImportAuctionStatistics.PATH = '/api/prebid-import/statistics';
